import { useIntl } from 'react-intl';
import { FunctionRuntime } from '@rossum/api-client/hooks';
import { Alert, AlertTitle, Box, Stack } from '@rossum/ui/material';
import { docsLinks } from '../../../../../constants/values';
import { boldText, link } from '../../../../../lib/formaterValues';
import {
  runtimesConfig,
  runtimeTypesConfig,
} from '../../extension-detail/config';

type Props = {
  runtimeDeprecationDate: Date;
  selectedRuntime: FunctionRuntime;
};

export const DeprecatedRuntimeAlert = ({
  runtimeDeprecationDate,
  selectedRuntime,
}: Props) => {
  const intl = useIntl();

  return (
    <Alert severity="warning" variant="filled" sx={{ fontWeight: 'normal' }}>
      <AlertTitle>
        {intl.formatMessage({
          id: 'containers.settings.extensions.function.runtime.deprecatedWarning.title',
        })}
      </AlertTitle>

      <Stack spacing={1}>
        <Box>
          {intl.formatMessage(
            {
              id: 'containers.settings.extensions.function.runtime.deprecatedWarning.message',
            },
            {
              deprecatedVersion: selectedRuntime,
              deprecatedDate: intl.formatDate(runtimeDeprecationDate, {
                dateStyle: 'medium',
              }),
              bold: boldText,
            }
          )}
        </Box>
        <Box>
          {intl.formatMessage(
            {
              id: 'containers.settings.extensions.function.runtime.deprecatedWarning.recommended',
            },
            {
              recommendedVersion:
                runtimeTypesConfig[runtimesConfig[selectedRuntime].type]
                  .default,
              link: link(docsLinks.runtimeDeprecations),
            }
          )}
        </Box>
      </Stack>
    </Alert>
  );
};
